import { addCommas } from './helpers';
import EmailSection from './EmailSection';

const EstimatedCosts = ({
  formData,
  brokerComissionPrice,
  nyTransferTaxRate,
  nyTransferTaxCost,
  nyStateTransferTaxRate,
  nyStateTransferTaxCost,
  attorneyFeePercent,
  isFee, setIsFee,
  isCost,setIsCost,
  isRevenue,setIsRevenue,
  setFormData,
  resetHandler,
  userParams, 
  setUserParams,
}) => {

    return(
        <div id='right' className="col-12 col-md-10 col-lg-6">
            <h4>Estimated Closing Costs</h4>
            <div className="row ">

              <div className="col-lg-8 col-md-6 col-6">
                
                <div className="title-cost"><span className="indicator1"></span>NYC Broker Commission</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="numbers">${addCommas(brokerComissionPrice)}</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="numbers">{formData.brokerCommission}%</div>
              </div>
              <div className='w-100'></div>

              <div className="col-lg-8 col-md-6 col-6">
                <div className="title-cost"><span className="indicator1"></span>NYC Transfer Tax</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="numbers">${addCommas(nyTransferTaxCost)}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="numbers">{nyTransferTaxRate}%</div>
              </div>
              <div className='w-100'></div>

              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator1"></span>NY State Transfer Tax</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${addCommas(nyStateTransferTaxCost)}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="">{nyStateTransferTaxRate}%</div>
              </div>
              <div className='w-100'></div>

              <div className="col-lg-8 col-md-6 col-6">
                <div className="title-cost"><span className="indicator1"></span>Seller's attorney fee</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="numbers">${addCommas(formData.sellerAttorneyFee)}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="numbers">{attorneyFeePercent}%</div>
              </div>
              <div className='w-100'></div>

              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Mortgage satisfaction recording fee</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                  <div className="">${isFee.mortgageSatisfRecFee}</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                {formData.existingMortgage === true && 
                  <div className="">{
                    formData.propertyType === '2'  ? 0 :
                    (isFee.mortgageSatisfRecFee * 100 /formData.salePrice).toFixed(3)
                  }%</div>
                }
                {formData.existingMortgage === false && <div>0%</div>}
              </div>
              <div className='w-100'></div>

              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Bank loan satisfaction fees</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${isFee.bankLoanSatisfFee}</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                {formData.existingMortgage === true && 
                  <div className="">{(isFee.bankLoanSatisfFee * 100 /formData.salePrice).toFixed(3)}%</div>
                }
                {formData.existingMortgage === false && <div>0%</div>}
              </div>
              <div className='w-100'></div>

              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Seller power of attorney recording fee
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${isFee.sellerPowerAttorneyFee}</div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                {formData.sellerPowerOfAttorney === true && 
                  <div className="">{(isFee.sellerPowerAttorneyFee * 100 /formData.salePrice).toFixed(3)}%</div>
                }
                {formData.sellerPowerOfAttorney === false && <div>0%</div>}
              </div>
              <div className='w-100'></div>

              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Building move-out fee
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${isFee.buildingMoveoutFee}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                {isFee.buildingMoveoutFee !== 0 && 
                  <div className="">{(isFee.buildingMoveoutFee * 100 /formData.salePrice).toFixed(3)}%</div>
                }
                {isFee.buildingMoveoutFee === 0 && <div>0%</div>}
              </div>
              <div className='w-100'></div>

              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Building managing agent closing fee
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${isFee.buildingManagingAgentCloseFee}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                {isFee.buildingManagingAgentCloseFee !== 0 && 
                  <div className="">{(isFee.buildingManagingAgentCloseFee * 100 /formData.salePrice).toFixed(3)}%</div>
                }
                {isFee.buildingManagingAgentCloseFee === 0 && <div>0%</div>}
              </div>
              <div className='w-100'></div>

              <div className="col-lg-8 col-md-6 col-6">
                <div className="title-cost"><span className="indicator1"></span>Building flip tax
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                {formData.buildingFlipTaxPercent !== 0 &&
                <div className="numbers">${addCommas((formData.buildingFlipTaxPercent * formData.salePrice / 100).toFixed(0))}</div>
                }
                {formData.buildingFlipTaxPercent === 0 && <div>$0</div>}
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                  <div className="numbers">{(formData.buildingFlipTaxPercent / 100 ).toFixed(2)}%</div>
              </div>
              <div className='w-100'></div>

              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Co-op UCC-3 Termination Fee
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${isFee.coopUCC3fee}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                {isFee.coopUCC3fee !== 0 &&
                  <div className="numbers">{(isFee.coopUCC3fee * 100 /formData.salePrice).toFixed(3)}%</div>
                }
                {isFee.coopUCC3fee === 0 && <div>0%</div>}
              </div>
              <div className='w-100'></div>

              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Co-op transfer tax filing fee
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${isFee.coopTransferTaxFee}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                {isFee.coopTransferTaxFee !== 0 &&
                  <div className="numbers">{(isFee.coopTransferTaxFee * 100 /formData.salePrice).toFixed(3)}%</div>
                }
                {isFee.coopTransferTaxFee === 0 && <div>0%</div>}
              </div>
              <div className='w-100'></div>

              <div className="col-lg-8 col-md-6 col-6">
                <div className=""><span className="indicator2"></span>Co-op stock transfer tax
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${isFee.coopStockTransferTax}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                {isFee.coopStockTransferTax !== 0 &&
                  <div className="numbers">{(isFee.coopStockTransferTax * 100 /formData.salePrice).toFixed(3)}%</div>
                }
                {isFee.coopStockTransferTax === 0 && <div>0%</div>}
              </div>
              <div className='w-100'></div>
              <div className="col-12">
                <div className="horizontal-line"></div>
              </div>
             
              <div className="col-lg-8 col-md-6 col-6 top-sel-cost">
                <div className="">Total Seller Closing Costs
              </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 top-sel-cost">
                <div className="">${addCommas(isCost)}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right top-sel-cost">
                <div className="">{(isCost * 100 /formData.salePrice).toFixed(2)}%</div>
              </div>
              <div className='w-100'></div>

              <div className="col-lg-8 col-md-6 col-6">
                <div className="">Net Sale Proceeds
              </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="">${addCommas(isRevenue)}
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3 text-right">
                <div className="">{(isRevenue * 100 /formData.salePrice).toFixed(2)}%</div>
              </div>
              <div className='w-100'></div>

              <span id="tabletEmail">
                <EmailSection 
                  formData={formData}
                  setFormData={setFormData}
                  resetHandler={resetHandler}
                  userParams={userParams} 
                  setUserParams={setUserParams}
                />
              </span>

            </div>
            <div className='text-center'>
              <button id="save-btn" type="button" class="btn btn-secondary btn-lg">Detailed Market Valuation</button>
            </div>
        </div>
    );
}

export default EstimatedCosts;